// Schemas declare their runtime-filled selects as `oneOf: []` and containers push the
// options in (pricings, providers, venues, categories, ...). When a venue has none of
// those, the list stays empty - and an empty oneOf/anyOf/enum is an INVALID JSON Schema.
//
// rjsf compiles the whole root schema with ajv, so one invalid node anywhere breaks the
// entire form, silently:
//   - every `dependencies` branch is skipped ("ignoring oneOf in dependencies"), so e.g.
//     the membership's "Näytetäänkö verkkokaupassa" never reveals the shop fields
//   - validation is skipped too, so `required` stops being enforced
//
// sanitizeSchema returns a COPY with those empty lists removed; the field falls back to a
// plain input of its type. It must not mutate: containers push options into module-level
// schema objects, and a deleted oneOf would make the next push throw.
const EMPTY_LIST_KEYWORDS = ['oneOf', 'anyOf', 'enum']

export const sanitizeSchema = (node) => {
  if (Array.isArray(node)) return node.map(sanitizeSchema)
  if (!node || typeof node !== 'object') return node
  const out = {}
  for (const [key, value] of Object.entries(node)) {
    if (EMPTY_LIST_KEYWORDS.includes(key) && Array.isArray(value) && value.length === 0) continue
    out[key] = sanitizeSchema(value)
  }
  return out
}
